<template>
  <div
    class="container-fluid p-4"
    :style="!completeLoad ? 'min-height: 90vh' : ''"
  >
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <div class="row g-4">
      <div class="col-12 col-lg-3">
        <nav
          class="sticky-kit nav-deep nav-deep-light d-lg-block d-md-none d-sm-none d-xs-none"
        >
          <div class="card">
            <div class="card-body p-0 p-md-4">
              <!-- mobile only -->
              <button
                class="clearfix btn btn-toggle btn-sm w-100 text-align-left shadow-md border rounded d-block d-lg-none js-togglified"
                data-bs-target="#nav_articleCategories"
                data-toggle-container-class="d-none d-sm-block bg-white shadow-md border animate-fadein rounded p-3"
                @click="btnCategoryClick"
              >
                <span class="group-icon px-2 py-2 float-start">
                  <i class="fi fi-bars-2" v-if="!isMenueActive"></i>
                  <i class="fi fi-close" v-if="isMenueActive"></i>
                </span>

                <span class="h5 py-2 m-0 float-start">
                  طبقه بندی مقاله‌ها
                </span>
                <a
                  class="float-end pointer text-danger-hover"
                  href="#"
                  @click="resetSelectedSubject"
                  ><i class="fi fi-reload text-dark text-danger-hover"></i
                ></a>
              </button>

              <!-- navbar : navigation -->
              <ul
                ref="nav_articleCategories"
                id="nav_articleCategories"
                class="nav flex-column d-lg-block mt-1 mt-lg-0 d-none"
              >
                <li v-if="!isMenueActive">
                  <!-- account name -->
                  <div
                    class="d-flex align-items-center mb-2 pb-4 border-bottom"
                  >
                    <div class="flex-none border rounded-circle">
                      <svg
                        width="24px"
                        height="24px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-bounding-box"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M5 2V0H0v5h2v6H0v5h5v-2h6v2h5v-5h-2V5h2V0h-5v2H5zm6 1v2h2v6h-2v2H5v-2H3V5h2V3h6zm1-2h3v3h-3V1zm3 11v3h-3v-3h3zM4 15H1v-3h3v3zM1 4V1h3v3H1z"
                        ></path>
                      </svg>
                      <!-- <img
                        src="../../assets/images/siteImages/article_image.svg"
                        width="48"
                      /> -->
                      <!-- <i
                        class="fi fi-layers-middle"
                        style="width: 48px height:48px"
                      ></i> -->
                    </div>
                    <div class="w-100 px-3">
                      <span class="float-start d-block fw-bold">
                        طبقه بندی مقاله‌ها
                      </span>
                      <a
                        class="float-end pointer text-danger-hover"
                        href="#"
                        @click="resetSelectedSubject"
                        ><i class="fi fi-reload text-dark text-danger-hover"></i
                      ></a>
                    </div>
                  </div>
                </li>
                <li
                  class="nav-item"
                  :class="{
                    active: searchArticleViewModel.subjectID == subject.id,
                  }"
                  v-for="subject in allSubjects"
                  :key="subject.id"
                >
                  <a
                    class="nav-link px-0 d-flex align-items-center"
                    href="#"
                    @click="this.subjectItemClick(subject.id)"
                  >
                    <i class="fi fi-arrow-end ms-2 small"></i>
                    <span>{{ subject.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <searchable-input
          mode="single"
          placeHolder="طبقه بندی مقالات"
          ref="articleCategoryComboBox"
          :options="allSubjectLables"
          v-model:inputValue="searchArticleViewModel.subjectID"
          @multiSelectChanged="allSubjectLablesChanged"
          inputThem="purpleThem"
          :canClear="true"
          topTitle=""
          inputTitle=""
          topTitleClass=""
          containerClass="my-1 d-block d-lg-none"
        />
      </div>

      <div class="col-12 col-lg-9">
        <div class="input-group-over d-block mb-1">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control searchBox"
              placeholder="جستجو در مقالات..."
              v-model="searchArticleViewModel.searchInputText"
              @keydown="searchTextInputKeyDown"
            />
          </div>

          <button type="submit" class="btn smaller" @click="getArticles">
            <i class="fi fi-search m-0"></i>
          </button>
          <button
            type="submit"
            class="btn smaller ms-5"
            v-if="searchArticleViewModel.searchInputText"
            @click="clearSearch"
          >
            <i class="fi fi-close m-0"></i>
          </button>
        </div>

        <!-- <h5
          v-if="searchArticleViewModel.subjectID != null"
          class="p-2 d-lg-block d-md-none d-sm-none d-xs-none"
        >
          <i class="fi fi-bars ms-2"></i>
          مقالات در دسته بندی:
          <span class="fw-bold"
            >"{{ getSubjectTitle(searchArticleViewModel.subjectID) }}"</span
          >
        </h5> -->
        <h5 v-if="searchArticleViewModel.keyWord != ''" class="p-2">
          <i class="fi fi-task-list ms-2"></i>
          نتایج جستجو برای عبارت:
          <span class="fw-bold">"{{ searchArticleViewModel.keyWord }}"</span>
        </h5>
        <div
          class="p-1 fs-5 text-secondary h-75 text-center"
          v-if="searchResult.length == 0"
        >
          <!-- <div class="y-middle">اطلاعاتی جهت نمایش وجود ندارد</div> -->
        </div>

        <div class="row col-border sectionArticle text-center">
          <div
            class="col-12 col-md-12 col-lg-4 mb-4 p-1"
            v-for="item in searchResult"
            :key="item.gUID"
          >
            <div class="card border-0 h-100 shadow rounded-xl article-card">
              <div class="card-title">
                <a :href="'/ArticleView/' + item.guid">
                  <h2 class="pt-1 fs-6">
                    {{ item.title }}
                  </h2>
                </a>
              </div>

              <div class="my-1 mb-3">
                <a :href="'/ArticleView/' + item.guid"
                  ><img
                    width="350"
                    :alt="item.title + ' ' + item.englishTitle"
                    :src="`${this.$store.state.apiBaseURL}/ST/Article/GetArticleImage?id=${item.id}`"
                /></a>
              </div>

              <!-- <div class="card-body ps-0 pe-0 text-gray-500">
                <hr class="my-1" />
                <div class="clearfix mb-2">
                  <a
                    :href="'/ArticleView/' + item.guid"
                    class="text-gray-700 ltr"
                    dir="ltr"
                    >{{ item.englishTitle }}</a
                  >
                  <p class="px-2 smaller text-gray-700">
                    <i class="fi fi-calendar"></i>
                    {{ getPersianPublishDate(item.publishDate) }}
                  </p>
                </div>
              </div> -->
            </div>
          </div>

          <div class="text-align-center my-2">
            <button
              class="btn btn-soft btn-blueSite btn-sm"
              v-if="hasMoreRecord && completeLoad"
              @click="moreArticleClick"
            >
              <i class="fi fi-arrow-down-full"></i>
              <span>نمایش بیشتر</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { isMobile } from 'mobile-device-detect';
import LoadingSpinner from '../../components/utility/loadingSpinner/LoadingSpinner.vue';
import SearchableInput from '../../components/form/searchableInput/SearchableInput.vue';

export default {
  components: {
    LoadingSpinner,
    SearchableInput,
  },
  data() {
    return {
      completeLoad: false,
      isMobile: isMobile,
      isMenueActive: false,
      allSubjects: [],
      allSubjectLables: [],
      searchResult: [],
      hasMoreRecord: true,
      searchArticleViewModel: {
        subjectID: null,
        recordCount: 9,
        keyWord: '',
        searchInputText: '',
      },
    };
  },
  methods: {
    btnCategoryClick() {
      //   this.$refs.nav_articleCategories.classList.toggle('d-none');
      //   this.$refs.nav_articleCategories.classList.toggle('d-sm-block');
      //   this.$refs.nav_articleCategories.classList.toggle('bg-white');
      //   this.$refs.nav_articleCategories.classList.toggle('shadow-md');
      //   this.$refs.nav_articleCategories.classList.toggle('border');
      //   this.$refs.nav_articleCategories.classList.toggle('animate-fadein');
      //   this.$refs.nav_articleCategories.classList.toggle('rounded');
      //   this.$refs.nav_articleCategories.classList.toggle('p-3');

      //   this.$refs.nav_articleCategories.classList.toggle(
      //     'd-none d-sm-block bg-white shadow-md border animate-fadein rounded p-3'
      //   );
      'd-none d-sm-block bg-white shadow-md border animate-fadein rounded p-3'
        .split(' ')
        .forEach((f) => {
          this.$refs.nav_articleCategories.classList.toggle(f);
        });
      this.isMenueActive = !this.isMenueActive;
    },
    getSubjectTitle(id) {
      return this.allSubjects.find((f) => f.id == id)?.title ?? '';
    },
    async allSubjectLablesChanged(id) {
      let that = this;
      that.searchArticleViewModel.subjectID = id;
      that.searchArticleViewModel.searchInputText = '';
      await this.getArticles();
    },
    async getAllSubjects() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get('/ST/Subject/GetAllSubjects')
        .then((response) => {
          that.allSubjects = response.data;
          that.allSubjectLables = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
          // this.$refs.spinner.hide();
        })
        .catch(() => {
          // this.$refs.notification.show({
          //   type: 'error',
          //   title: `عملیات ویرایش ردیف انتخاب شده با خطا مواجه گردید`,
          // });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async subjectItemClick(id) {
      let that = this;
      that.searchArticleViewModel.subjectID = id;
      that.searchArticleViewModel.searchInputText = '';
      await this.getArticles();
    },
    async searchTextInputKeyDown(e) {
      if (e.key == 'Enter') {
        // this.searchArticleViewModel.subjectID = null;
        await this.getArticles();
      }
    },
    async clearSearch() {
      this.searchArticleViewModel.keyWord = '';
      this.searchArticleViewModel.searchInputText = '';
      await this.getArticles();
    },
    async getArticles() {
      let that = this;
      if (that.searchArticleViewModel.searchInputText) {
        that.searchArticleViewModel.keyWord =
          that.searchArticleViewModel.searchInputText;
      } else {
        that.searchArticleViewModel.keyWord = '';
      }

      this.$refs.spinner.show();
      await axios
        .post('/ST/Article/SearchArticles', that.searchArticleViewModel)
        .then((response) => {
          // this.searchArticleViewModel.subjectID = null;
          that.searchResult = response.data.articleData;
          that.hasMoreRecord =
            response.data.allRecourdCount > response.data.articleData.length;
        })
        .catch(() => {
          // this.$refs.notification.show({
          //   type: 'error',
          //   title: `عملیات ویرایش ردیف انتخاب شده با خطا مواجه گردید`,
          // });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    getPersianPublishDate(date) {
      /* eslint-disable */
      return new persianDate(new Date(date)).format('LLLLL');
    },
    async moreArticleClick() {
      this.searchArticleViewModel.recordCount += 9;
      await this.getArticles();
    },
    async resetSelectedSubject() {
      this.searchArticleViewModel.subjectID = null;
      await this.getArticles();
    },
  },
  async mounted() {
    try {
      this.$refs.spinner.show();
      await this.getAllSubjects();
      await this.getArticles();
      this.completeLoad = true;
    } finally {
      this.$refs.spinner.hide();
    }
  },
};
</script>
<style scopped>
.article-title {
  height: 40px !important;
}
.sectionArticle {
}
.sectionArticle a {
  color: var(--bs-body-color);
}
.sectionQuestion a {
  color: var(--bs-body-color);
}
.form-floating > label {
  width: unset !important;
  left: unset !important;
}
</style>
